export const
    colTableRef = 'f7-list-item-ref';
